import { React, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaRegTrashAlt } from "react-icons/fa";

export default function ProductB({
  items,
  handleDeleteProductB,
  onUploadSuccess,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleNextPage = () => {
    const totalPages = Math.ceil(items.length / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <>
      <h4 className="text-center" style={{ marginTop: "30px" }}>
        Recently Generated iSheets (Product B)
      </h4>
      <div className="table-responsive">
        <table
          className="table table-bordered border-primary"
          style={{ border: "1px solid red", fontSize: "14px" }}
        >
          <thead>
            <tr>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                #
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Riverchain ID
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Borrower's name(English)
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Created date
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Created by
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Modified by
              </th>
              <th style={{ border: "1px solid green", fontWeight: "bold" }}>
                Delete
              </th>
            </tr>
          </thead>
          <tbody>
            {items && items.length > 0 ? (
              [...items]
                .sort((a, b) => {
                  const dateA = new Date(
                    a.column.find((col) => col.attributecolumnid === "742")
                      ?.displaydata?.value || 0
                  );
                  const dateB = new Date(
                    b.column.find((col) => col.attributecolumnid === "742")
                      ?.displaydata?.value || 0
                  );
                  return dateB - dateA;
                })
                .slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )
                .map((item, index) => (
                  <tr key={index}>
                    {/* Serial Number */}
                    <td
                      style={{
                        border: "1px solid green",
                        fontWeight: "bold",
                      }}
                    >
                      {index + 1}
                    </td>

                    {/* Riverchain ID */}
                    {(() => {
                      const firstColumn = item.column.find(
                        (col) => col.attributecolumnid === "745"
                      );
                      return firstColumn ? (
                        <td style={{ border: "1px solid green" }}>
                          {firstColumn.displaydata?.value || "--"}
                        </td>
                      ) : null;
                    })()}

                    {(() => {
                      const firstColumn = item.column.find(
                        (col) => col.attributecolumnid === "746"
                      );
                      return firstColumn ? (
                        <td style={{ border: "1px solid green" }}>
                          {firstColumn.displaydata?.value || "--"}
                        </td>
                      ) : null;
                    })()}

                    {/* Created Date */}
                    {(() => {
                      const firstColumn = item.column.find(
                        (col) => col.attributecolumnid === "744"
                      );
                      return firstColumn ? (
                        <td style={{ border: "1px solid green" }}>
                          {firstColumn.displaydata?.value || "--"}
                        </td>
                      ) : null;
                    })()}

                    {(() => {
                      const firstColumn = item.column.find(
                        (col) => col.attributecolumnid === "741"
                      );
                      return firstColumn ? (
                        <td style={{ border: "1px solid green" }}>
                          {firstColumn.displaydata?.lookupusers?.lookupuser
                            ?.userdisplayname || "--"}
                        </td>
                      ) : null;
                    })()}

                    {/* Display other columns */}
                    {item.column
                      .filter((col) => col.attributecolumnid !== "743")
                      .slice(0, 1)
                      .map((col, colIndex) => (
                        <td
                          key={colIndex}
                          style={{ border: "1px solid green" }}
                        >
                          {col.rawdata?.value
                            ? col.rawdata.value
                            : col.displaydata?.lookupusers?.lookupuser
                                ?.userdisplayname
                            ? String(
                                col.displaydata.lookupusers.lookupuser
                                  .userdisplayname
                              )
                            : col.rawdata?.time
                            ? col.rawdata.time
                            : col.displaydata?.value
                            ? col.displaydata.value
                            : "--"}
                        </td>
                      ))}

                    {/* Delete Button */}
                    <td
                      style={{
                        border: "1px solid green",
                        textAlign: "center",
                      }}
                    >
                      <button
                        onClick={() =>
                          handleDeleteProductB(item.itemid, onUploadSuccess)
                        }
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          border: "none",
                          padding: "5px 10px",
                          cursor: "pointer",
                          borderRadius: "5px",
                        }}
                      >
                        <FaRegTrashAlt /> Delete
                      </button>
                    </td>
                  </tr>
                ))
            ) : (
              <h5 styele={{ textAlign: "center" }}>Data is loading...</h5>
            )}
          </tbody>
        </table>

        <div className="d-flex justify-content-between align-items-center mt-3">
          <button
            className="btn btn-outline-primary"
            onClick={handlePrevPage}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>Page {currentPage}</span>
          <button
            className="btn btn-outline-primary"
            onClick={handleNextPage}
            disabled={currentPage === Math.ceil(items.length / itemsPerPage)}
          >
            Next
          </button>
        </div>
      </div>
    </>
  );
}
